import { useEffect } from "react";
import { X } from "lucide-react";

export function ModalShell({ open, onClose, title, children, testId, maxWidth = "max-w-sm" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-end sm:items-center justify-center p-4 fade-up"
      onClick={onClose}
      data-testid={testId}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`bg-white rounded-3xl w-full ${maxWidth} p-5 max-h-[85vh] overflow-y-auto`}
      >
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-display font-bold text-xl text-slate-900">{title}</h2>
          <button onClick={onClose} className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center active:scale-90 transition" data-testid={`${testId}-close`}>
            <X size={16} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
